<template>
  <span>
    <router-link :to="{ name: 'StaffDoctorVisits', params: {id: object.id }}"
                 class="data-table-action"
                 :title="$t('visits')"
                 v-b-tooltip.hover
    >
      <CalendarSvg class="svg-light"/><span class="action-button-mob-title">{{ $t('visits') }}</span>
    </router-link>
    <a @click="editSchedule"
       v-if="rights.includes('work_time_edit')"
       :title="$t('schedule')"
       v-b-tooltip.hover
       class="data-table-action">
      <ClockSvg class="svg-light"/><span class="action-button-mob-title">{{ $t('schedule') }}</span>
    </a>
    <a @click="sort"
       :title="$t('sorting')"
       v-b-tooltip.hover
       class="data-table-action">
      <SortSvg class="svg-stroke-light svg-size-xl"/><span class="action-button-mob-title">{{ $t('sorting') }}</span>
    </a>
  <a @click="toggleDoctor"
     v-if="rights.includes('create_docs')"
     :title="object.blocked == 0 ? $t('block') : $t('activate')"
     v-b-tooltip.hover
     class="data-table-action">
    <BlockSvg v-if="object.blocked == 0"/>
    <ActivateSvg class="svg-light" v-if="object.blocked == 1"/>
    <span class="action-button-mob-title">{{ object.blocked == 0 ? $t('block') : $t('activate') }}</span>
  </a>
    </span>
</template>

<script>

import BlockSvg from '@/assets/svg-vue/general/block.svg'
import ActivateSvg from '@/assets/svg-vue/form/tick.svg'
import ClockSvg from '@/assets/svg-vue/calendar/clock2.svg'
import CalendarSvg from '@/assets/svg-vue/calendar/calendar_plus.svg'
import SortSvg from '@/assets/svg-vue/general/sort.svg'
import { EloquentService } from "@/services/api/eloquent.api.service"
import { doctorAdapter } from '@/adapters/staff/doctor'
import {mapState} from "vuex"

export default {
  name: "StaffDatatableDoctorActions",
  components: {
    BlockSvg,
    ActivateSvg,
    ClockSvg,
    SortSvg,
    CalendarSvg
  },
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    ...mapState({
      rights: state => state.auth.rights,
    }),
  },
  methods: {
    toggleDoctor() {
      let formData = new FormData()
      let data = doctorAdapter(this.object)
      delete data.full
      data.blocked = this.object.blocked == 1 ? 0 : 1
      formData = this.appendFormdata(formData, data)
      EloquentService.update('doctor', this.object.id, formData).then(() => {
        this.$store.commit('incrementDataTableCounter')
      })
    },
    editSchedule() {
      this.$store.commit('setDoctor', this.copyObject(this.object))
      this.$nextTick(() => {
        this.$bvModal.show('doctor-schedule-modal')
      })
    },
    sort() {
      this.$bvModal.show('sort-modal')
    }
  }
}
</script>
